import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import * as PropTypes from 'prop-types';
import Icon from '../Icon';
import { isString, isNumber } from '@utiljs/is';

var Step = /*#__PURE__*/function (_React$Component) {
  _inherits(Step, _React$Component);

  var _super = _createSuper(Step);

  function Step() {
    var _this;

    _classCallCheck(this, Step);

    _this = _super.apply(this, arguments);

    _this.handleClick = function () {
      var _this$props = _this.props,
          skey = _this$props.skey,
          onChange = _this$props.onChange;

      if (onChange) {
        onChange(Number(skey));
      }
    };

    _this.renderSkey = function () {
      var _this$props2 = _this.props,
          skey = _this$props2.skey,
          status = _this$props2.status,
          current = _this$props2.current;

      if (status === 'finish' || current === 'finish') {
        return /*#__PURE__*/React.createElement("div", {
          className: "roo-steps-icon-content"
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "check"
        }));
      }

      if (status === 'error' || current === 'error') {
        return /*#__PURE__*/React.createElement("div", {
          className: "roo-steps-icon-content"
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "close"
        }));
      }

      if (isString(skey) || isNumber(skey)) {
        return /*#__PURE__*/React.createElement("div", {
          className: "roo-steps-icon-content"
        }, skey);
      }

      return skey;
    };

    _this.getStepStatus = function () {
      var _this$props3 = _this.props,
          status = _this$props3.status,
          current = _this$props3.current;

      if (status === 'process') {
        return 'roo-steps-active';
      }

      if (status !== 'wait') {
        return "roo-steps-".concat(status);
      }

      return "roo-steps-".concat(current);
    };

    _this.renderStepTail = function () {
      var _this$props4 = _this.props,
          textPosition = _this$props4.textPosition,
          direction = _this$props4.direction;

      if (direction === 'horizontal' && textPosition === 'right') {
        return null;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "roo-steps-tail"
      });
    };

    _this.renderStepContent = function () {
      var _this$props5 = _this.props,
          title = _this$props5.title,
          desc = _this$props5.desc,
          direction = _this$props5.direction;

      if (direction === 'vertical') {
        return /*#__PURE__*/React.createElement("div", {
          className: "roo-steps-item-content",
          onClick: _this.handleClick
        }, /*#__PURE__*/React.createElement("div", {
          className: "roo-steps-title"
        }, title), /*#__PURE__*/React.createElement("div", {
          className: "roo-steps-desc"
        }, desc));
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "roo-steps-item-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "roo-steps-title",
        onClick: _this.handleClick
      }, title), /*#__PURE__*/React.createElement("div", {
        className: "roo-steps-desc"
      }, desc));
    };

    return _this;
  }

  _createClass(Step, [{
    key: "render",
    value: function render() {
      var isButton = this.props.isButton;
      return /*#__PURE__*/React.createElement("li", {
        className: "roo-steps-item ".concat(this.getStepStatus()),
        onClick: this.handleClick,
        role: isButton ? 'button' : ''
      }, this.renderStepTail(), /*#__PURE__*/React.createElement("div", {
        className: "roo-steps-icon"
      }, this.renderSkey()), this.renderStepContent());
    }
  }]);

  return Step;
}(React.Component);

Step.propTypes = {
  status: PropTypes.oneOf(['wait', 'finish', 'process', 'error']),
  title: PropTypes.string,
  desc: PropTypes.string,
  skey: PropTypes.node,
  textPosition: PropTypes.string,
  current: PropTypes.string,
  direction: PropTypes.oneOf(['vertical', 'horizontal'])
};
Step.defaultProps = {
  status: 'wait',
  title: '',
  desc: '',
  skey: '',
  current: '',
  direction: 'horizontal',
  textPosition: 'bottom'
};
export default Step;